import { Star, ThumbsUp, ThumbsDown, User } from 'lucide-react';

const ReviewCard = ({ review }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }).format(date);
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 mb-4">
      {/* Review Header */}
      <div className="flex items-start justify-between gap-4 mb-3">
        <div className="flex items-center gap-3">
          {/* Reviewer Avatar */}
          {review.reviewer?.avatar_url ? (
            <img
              src={review.reviewer.avatar_url}
              alt={review.reviewer?.name}
              className="w-10 h-10 rounded-full object-cover"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          ) : (
            <div className="w-10 h-10 rounded-full bg-sky-100 flex items-center justify-center">
              <User size={20} className="text-sky-600" />
            </div>
          )}

          <div>
            <p className="font-semibold text-gray-900">
              {review.reviewer?.name || 'Anonymous'}
            </p>
            <p className="text-sm text-gray-500">{formatDate(review.created_at)}</p>
          </div>
        </div>

        {/* Rating */}
        <div className="flex items-center gap-1">
          {[...Array(5)].map((_, i) => (
            <Star
              key={i}
              size={16}
              className={
                i < review.rating
                  ? 'fill-yellow-400 text-yellow-400'
                  : 'text-gray-300'
              }
            />
          ))}
          <span className="font-bold text-gray-900 ml-1">{review.rating}.0</span>
        </div>
      </div>

      {/* Review Title */}
      {review.title && (
        <h4 className="font-bold text-gray-900 mb-2">{review.title}</h4>
      )}

      {/* Review Content */}
      <p className="text-gray-700 mb-4 whitespace-pre-wrap">{review.content}</p>

      {/* Review Images */}
      {review.media_urls && review.media_urls.length > 0 && (
        <div className="flex gap-2 mb-4 flex-wrap">
          {review.media_urls.slice(0, 5).map((url, index) => (
            <div key={index} className="w-16 h-16 rounded overflow-hidden">
              <img
                src={url}
                alt={`Review media ${index + 1}`}
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
          ))}
          {review.media_urls.length > 5 && (
            <div className="w-16 h-16 rounded bg-gray-100 flex items-center justify-center text-gray-600 text-sm font-bold">
              +{review.media_urls.length - 5}
            </div>
          )}
        </div>
      )}

      {/* Review Footer - Helpful/Unhelpful */}
      {/* <div className="flex items-center gap-4 text-sm text-gray-600">
        <button className="flex items-center gap-1 hover:text-emerald-600 transition">
          <ThumbsUp size={16} />
          <span>{review.helpful_count || 0}</span>
        </button>
        <button className="flex items-center gap-1 hover:text-red-600 transition">
          <ThumbsDown size={16} />
          <span>{review.unhelpful_count || 0}</span>
        </button>
      </div> */}

      {/* Business Owner Response */}
      {review.review_responses && review.review_responses.length > 0 && (
        <div className="mt-4 pt-4 border-t border-gray-100 bg-gray-50 p-3 rounded">
          <p className="text-xs font-bold text-gray-500 uppercase mb-2">Business Response</p>
          <p className="text-gray-700 text-sm">{review.review_responses[0].response_text}</p>
          <p className="text-xs text-gray-500 mt-2">
            {new Date(review.review_responses[0].created_at).toLocaleDateString()}
          </p>
        </div>
      )}
    </div>
  );
};

export default ReviewCard;
